import React, { useState, useEffect } from 'react';
import { SignatureReact } from '@pepper/signature-react';
import CustomModal from '../../components/CustomModal/CustomModal';
import {
  ErrorType,
  ErrorTypeCommon,
  StatusType,
} from '../../interfaces/ErrorCode';
import {
  AuthToken,
  CreateSignatureProps,
  SignatureData,
  SignatureTypes,
} from '../../interfaces/Signature';
import {
  CustomSignature,
  CustomTop,
  SignatureContainer,
} from '../../AppStyledComponents';
import CustomFooter from '../../components/CustomFooter/CustomFooter';
import CustomHeader from '../../components/CustomHeader/CustomHeader';
import { CustomError } from '../../components/CustomError/CustomError';

const CreateSignature: React.FC<CreateSignatureProps> = ({ putProps }) => {
  const [myData, setMyData] = useState<any>(putProps?.signatureData);
  const [authToken, setAuthToken] = useState<AuthToken | undefined>(
    putProps?.aToken
  );
  const [updateData, setUpdateData] = useState<any>();
  const [successEnd, setSuccessEnd] = useState<boolean>(false);
  const [signatureReady] = useState<boolean>(true);
  const [signatureError, setSignatureError] = useState<ErrorTypeCommon>();
  const [isApp, setIsApp] = useState<boolean>(false);
  const mode = putProps?.mode.toLocaleLowerCase();
  const style = putProps?.signatureData?.style;
  const environment = {
    type: process.env.REACT_APP_ENV,
  };
  useEffect(() => {
    if (updateData) {
      recivedEmitDataUpdate(updateData);
    }
  }, [updateData]);

  useEffect(() => {
    setMyData(putProps?.signatureData);
    setAuthToken(putProps?.aToken);
  }, [putProps]);

  useEffect(() => {
    if (updateData) {
      setMyData(updateData);
    }
  }, [updateData]);

  const recivedEmitDataUpdate = (e: any) => {
    setUpdateData(e?.statemydataupdate);
  };

  const isValidSignatureType = (value: any) => {
    return Object.values(SignatureTypes).includes(value);
  };

  const typeSignature = isValidSignatureType(
    putProps?.signatureData?.third_party
  )
    ? putProps?.signatureData?.third_party
    : SignatureTypes.PEP;

  const handleSuccess = (url_ok: any) => {
    setSuccessEnd(true);
    if (url_ok !== null && url_ok !== '') {
      window.location.href = `${url_ok}`;
    } else {
      setMyData({ ...myData, status: 'SGNOW' });
    }
  };

  const handlePepperError = (error: ErrorType | ErrorTypeCommon) => {
    console.log('error', error);
    switch (error) {
      case ErrorTypeCommon.ESG0016:
        //número máximo de reintentos alcanzado
        setSignatureError(ErrorTypeCommon.ESG0016);
        if (myData.url_ko !== null && myData.url_ko !== '') {
          window.location.href = `${myData.url_ko}`;
        } else {
          setMyData({ ...myData, status: StatusType.ERR });
          setSignatureError(ErrorTypeCommon.UNKNOWN_ERROR);
        }
        break;
      case ErrorTypeCommon.ESG0015:
        //pin expirado
        setSignatureError(ErrorTypeCommon.ESG0015);
        break;
      case ErrorTypeCommon.ESG0014:
        //pin incorrecto
        setSignatureError(ErrorTypeCommon.ESG0014);
        break;
      default:
        if (myData.url_ko !== null && myData.url_ko !== '') {
          window.location.href = `${myData.url_ko}`;
        } else {
          setMyData({ ...myData, status: StatusType.ERR });
          setSignatureError(ErrorTypeCommon.UNKNOWN_ERROR);
        }

    }
    typeSignature === SignatureTypes.PEP &&
      setTimeout(() => {
        setSignatureError(undefined);
      }, 3000);
  }

  const handleError = (error: ErrorType | ErrorTypeCommon) => {
    if (typeSignature === SignatureTypes.PEP) {
      handlePepperError(error);
    } else {
      if (myData.url_ko !== null && myData.url_ko !== '') {
        window.location.href = `${myData.url_ko}`;
      } else {
        setMyData({ ...myData, status: StatusType.ERR });
        setSignatureError(ErrorTypeCommon.UNKNOWN_ERROR);
      }
    }

  };

  const handleCancel = () => {
    if (myData.url_cancel !== null && myData.url_cancel !== '') {
      window.location.href = `${myData.url_cancel}`;
    } else {
      setMyData({ ...myData, status: 'CANCEL' });
    }
  };

  const handleContractData = () => {}

  return (
    /* <div className='custom-pepper' style={putProps?.mode !== 'iframe' ? undefined : { background: 'white' }}>*/
    <CustomTop>
      {myData?.signature_id &&
        (myData?.status === 'INI' || myData?.status === 'PRO') && mode !== 'iframe' && (
          <CustomHeader
            firmaStyle={style || ''}
            typeSignature={typeSignature}
          />
        )}
      {myData?.status === 'ERR' && <CustomModal error={true} />}{' '}
      {/*contrato con error*/}
      {myData?.status === 'CANCEL' && <CustomModal can={true} />}{' '}
      {/*contrato se acaba de cancelar*/}
      {myData?.status === 'CAN' && <CustomModal canNow={true} />}{' '}
      {/*contrato cancelado*/}
      {myData?.status === 'ANU' && <CustomModal anu={true} />}{' '}
      {/*contrato anulado */}
      {myData?.status === 'SGN' && <CustomModal firmado={true} />}{' '}
      {/*contrato ya firmado*/}
      {myData?.status === 'SGNOW' && <CustomModal show={true} />}{' '}
      {/*contrato se acaba de firmar*/}
      {myData?.signature_id &&
        (myData?.status === 'INI' || myData?.status === 'PRO') && (
          <SignatureContainer>
            <CustomSignature>
              {signatureError && typeSignature === SignatureTypes.PEP && (
                <CustomError errorCode={signatureError} />
              )}
              {authToken && environment && !successEnd && signatureReady && (
                <SignatureReact
                  /*creditProposalID={getCreditProposalId(myData.tags)}*/
                  signatureData={myData}
                  currentEnvironment={environment}
                  token={authToken?.access_token}
                  successEnd={handleSuccess}
                  generalPadding="0px 20px"
                  errorMessage={handleError}
                  cancel={handleCancel}
                  urlResponse
                  isApp={isApp}
                  sendContractData={handleContractData}
                  stepEvent={() => {}}
                />
              )}
            </CustomSignature>
          </SignatureContainer>
        )}
      {mode !== 'iframe' &&
        myData?.signature_id &&
        (myData?.status === 'INI' || myData?.status === 'PRO') &&
        typeSignature === SignatureTypes.PEP && (
          <CustomFooter
            typeSignature={typeSignature}
            firmaStyle={style || ''}
            emitRecancel={handleCancel}
            texts={'Salir'}
          />
        )}
    </CustomTop>
  );
};

export default CreateSignature;
